import {
  Directive,
  Input,
  HostBinding,
  HostListener,
  ElementRef,
  NgZone,
  OnInit,
  OnDestroy
} from '@angular/core';

import { Observable } from 'rxjs';

import { DropdownService } from './dropdown.service';
import {takeWhile} from 'rxjs/operators';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';


@Directive({
  selector: '[dropdownBtn]',
  exportAs: 'dropdown-btn'
})
export class DropdownBtnDirective implements OnInit, OnDestroy {

  /**
   * Square dropdown with arrow
  */
  @HostBinding('class.square-arrow-dropdown-btn')
  @Input()
  squareArrow: boolean = false;


  /**
   * Dropdown Arrow
  */
  @HostBinding('class.dropdown-toggle')

  @HostBinding('class.dropdown-toggle-split')
  @Input() dropdownToggle: boolean = false;

  @HostBinding('class.version-2')
  @Input() isVersion2: boolean = false;

  /*
    * Disable click
  */
  @Input() disabled: boolean = false;

  /**
   * Add bootstrap .btn class
  */
  @HostBinding('class.btn') @Input() isBootstrapBtn: boolean = true;

  @HostBinding('attr.data-toggle') dataToggle: string = 'dropdown';

  @HostBinding('attr.aria-haspopup') ariaHaspopup: string = 'true';

  @HostBinding('attr.aria-expanded') ariaExpanded: string = 'false';

  private isActive: boolean = true;

  constructor(
    private dropdownService: DropdownService,
    private ngZone: NgZone,
    private elementRef: ElementRef,
  ) {}

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(this.elementRef.nativeElement, 'click')
      .pipe(takeWhile(() => this.isActive))
      .subscribe((event: MouseEvent) => {
        if (this.disabled) { return; }
        this.dropdownService.toggle();
      });
    });
  }

  ngOnDestroy() {
    this.isActive = false;
  }

}
